module.exports = __webpack_public_path__ + "static/media/aztec.7ab9c15b.jpg";